import { Component, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="p-12 text-center">
          <h1 className="text-2xl mb-4">Something went wrong</h1>
          <pre className="text-sm text-red-400 bg-red-900/20 p-4 rounded overflow-auto whitespace-pre-wrap text-left max-w-2xl mx-auto">
            {this.state.error.message}
          </pre>
          <button
            type="button"
            onClick={() => location.reload()}
            className="mt-4 px-4 py-2 bg-chain-600 hover:bg-chain-500 rounded text-white"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
